module.exports = "<i class=\"c-helper-text__icon icon__n icon__n--{{icon}}\"></i>\n<span *ngIf=\"text\" class=\"c-helper-text__value\" [innerHTML]=\"text | sanitizeHtml\"></span>\n<span *ngIf=\"!text\" class=\"c-helper-text__value\"><ng-content></ng-content></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/helper-text/helper-text.component.html
// module id = ./src/app/modules/common-module/components/helper-text/helper-text.component.html
// module chunks = 9